// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-bar .swiper-btn-next.swiper-button-disabled[data-v-bc3af360], .menu-bar .swiper-btn-next.swiper-button-disabled+div[data-v-bc3af360], .menu-bar .swiper-btn-prev.swiper-button-disabled[data-v-bc3af360], .menu-bar .swiper-btn-prev.swiper-button-disabled+div[data-v-bc3af360]{display:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
